import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "dots-3-horizontal-17", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "currentColor", fillOpacity: 0.2, stroke: "currentColor" },
        React.createElement("circle", { cx: 8.5, cy: 8.5, r: 1 }),
        React.createElement("circle", { cx: 3.5, cy: 8.5, r: 1 }),
        React.createElement("circle", { cx: 13.5, cy: 8.5, r: 1 })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
